export default __webpack_public_path__ + "static/footer-logo-a1c1d188bd39d1ad33f68d3cb1d45c04.png";